"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTabs = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_2 = __importDefault(require("react"));
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var styles_1 = require("./styles");
function TabPanel(props) {
    var children = props.children, value = props.value, index = props.index, other = __rest(props, ["children", "value", "index"]);
    return (jsx_runtime_1.jsx("div", __assign({ role: "tabpanel", hidden: value !== index, id: "simple-tabpanel-" + index, "aria-labelledby": "simple-tab-" + index }, other, { children: value === index && jsx_runtime_1.jsx(Box_1.default, __assign({ p: 3 }, { children: children }), void 0) }), void 0));
}
function a11yProps(index) {
    return {
        id: "simple-tab-" + index,
        'aria-controls': "simple-tabpanel-" + index,
    };
}
/**
 * Componente SimpleTabs
 * Permite a exibição de conteúdos organizados por abas.
 * @param {ITabs.tabs} tabs abas a serem exibidas
 * @param {ITabs.content} content abas a serem exibidas
 *
 */
var SimpleTabs = function (_a) {
    var content = _a.content, tabs = _a.tabs;
    var _b = __read(react_2.default.useState(0), 2), value = _b[0], setValue = _b[1];
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    return (jsx_runtime_1.jsxs(styles_1.Container, { children: [jsx_runtime_1.jsx(AppBar_1.default, __assign({ position: "static" }, { children: jsx_runtime_1.jsx(Tabs_1.default, __assign({ value: value, onChange: handleChange, textColor: "primary", indicatorColor: "primary" }, { children: tabs.map(function (tab) {
                        return (react_1.createElement(Tab_1.default, __assign({ label: "" + tab.label }, a11yProps(tab.anchorTab), { key: String(tab.anchorTab) })));
                    }) }), void 0) }), void 0),
            content.map(function (el) { return (jsx_runtime_1.jsx(TabPanel, __assign({ value: value, index: el.anchorContent }, { children: el.children }), el.anchorContent)); })] }, void 0));
};
exports.SimpleTabs = SimpleTabs;
exports.default = exports.SimpleTabs;
//# sourceMappingURL=index.js.map